import React from "react";
import { FileArchive, FileImage, FileSpreadsheet, FileText, type LucideIcon } from "lucide-react";

export const FileIcon = ({ mimeType }: { mimeType: string }): React.ReactElement => {
    let Icon: LucideIcon = FileImage;
    if (mimeType === "aplication/msword" || mimeType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        Icon = FileText;
    } else if (mimeType === "application/pdf" || mimeType === "text/plain") {
        Icon = FileText;
    } else if (
        mimeType === "application/vnd.ms-excel" ||
        mimeType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        mimeType === "text/csv"
    ) {
        Icon = FileSpreadsheet;
    } else if (mimeType === "application/zip") {
        Icon = FileArchive;
    }

    return <Icon size={20} />;
};
